import api from "./axios"; // your existing axios instance (src/api/api.js)

export const supportApi = {
  // GET /support/tickets?status=&search=&per_page=
  listTickets: async (params = {}) => {
    const { data } = await api.get("/support/tickets", { params });
    return data;
  },

  // GET /support/tickets/:id
  getTicket: async (id) => {
    const { data } = await api.get(`/support/tickets/${id}`);
    return data;
  },

  

  // POST /support/tickets  (multipart if attachments are included)
  createTicket: async ({ category, subject, description, priority = "medium", attachments = [] }) => {
    const form = new FormData();
    form.append("category", category);
    form.append("subject", subject);
    form.append("description", description);
    form.append("priority", priority);
    attachments.forEach((file) => form.append("attachments[]", file));

    const { data } = await api.post("/support/tickets", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
  },

  // POST /support/tickets/:id/replies
  replyToTicket: async (id, message) => {
    const { data } = await api.post(`/support/tickets/${id}/replies`, { message });
    return data;
  },

  // PATCH /support/tickets/:id/status  (staff only)
  updateTicketStatus: async (id, status, assignedTo) => {
    const { data } = await api.patch(`/support/tickets/${id}/status`, {
      status,
      assigned_to: assignedTo,
    });
    return data;
  },

  // GET /support/agents  (staff only) — NEW, needs a matching backend route
  listAgents: async () => {
    const { data } = await api.get("/support/agents");
    return data;
  },

  // POST /support/tickets/:id/remarks  (staff only) — NEW, needs a matching backend route
  addInternalRemark: async (id, message) => {
    const { data } = await api.post(`/support/tickets/${id}/remarks`, { message });
    return data;
  },

  // POST /faq/feedback
  submitFaqFeedback: async ({ faqKey, category, helpful }) => {
    const { data } = await api.post("/faq/feedback", {
      faq_key: faqKey,
      category,
      helpful,
    });
    return data;
  },

    // POST /support/tickets/:id/remarks  (staff only)
  addInternalRemark: async (id, message) => {
    const { data } = await api.post(`/support/tickets/${id}/remarks`, { message });
    return data;
  },
};